export default __webpack_public_path__ + "static/media/icon_resurssit_summary.df98ec2d.svg";